import React, { useEffect } from 'react';
import { rubros } from '../../json/rubros';
import './rubros.css';
import { Link } from 'react-router-dom';

const Rubros = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="rubros-page">
      <div className="container">
        <section className="rubros-hero">
          <div className="rubros-hero-main">
            <div className="rubros-hero-icon" aria-hidden="true">
              <span>✓</span>
            </div>

            <div className="rubros-hero-copy">
              <h1>Artículo 69 Ley de Transparencia (48 Rubros)</h1>
              <span className="rubros-title-line" />
              <p>
                Consulta la información que la Secretaría de Contraloría pone a tu
                disposición conforme a lo establecido en el artículo 69 de la Ley de
                Transparencia y Acceso a la Información Pública para el Estado de Hidalgo.
              </p>
            </div>
          </div>

          <aside className="rubros-info-card">
            <div className="rubros-info-icon" aria-hidden="true">i</div>
            <div className="rubros-info-content">
              <h2>¿Qué es el Artículo 69?</h2>
              <p>
                Establece la información que los sujetos obligados deben poner a disposición
                del público de manera permanente.
              </p>
            </div>
            <span className="rubros-info-arrow" aria-hidden="true">›</span>
          </aside>
        </section>

        <section className="rubros-section">
          <div className="rubros-section-header">
            <div>
              <h2>Rubros de Información</h2>
              <span className="rubros-section-line" />
            </div>

            <div className="rubros-count" aria-label="48 rubros disponibles">
              <span className="rubros-count-grid" aria-hidden="true">
                <i></i><i></i><i></i><i></i>
              </span>
              <span>Ver todos (48)</span>
            </div>
          </div>

          <div className="rubros-grid">
            {rubros.map((item, index) => {
              const numero = String(index + 1).padStart(2, '0');
              const destino = item.url ? item.url : 'DetalleRubro/' + item.nombre;

              return (
                <Link key={`${item.nombre}-${index}`} to={destino} className="rubro-card">
                  <div className="rubro-card-icon">
                    <img
                      src={'http://cdn.hidalgo.gob.mx/plantilla_secretarial/Rubros/PNG/' + item.icono}
                      alt=""
                      loading="lazy"
                    />
                  </div>

                  <span className="rubro-card-divider" aria-hidden="true" />

                  <div className="rubro-card-content">
                    <span className="rubro-card-number">{numero}</span>
                    <h3>{item.nombre}</h3>
                  </div>

                  <span className="rubro-card-arrow" aria-hidden="true">›</span>
                </Link>
              );
            })}
          </div>

          <div className="rubros-history-wrap">
            <Link className="rubros-historicos" to="RubrosHistoricos">
              <span className="rubros-history-icon" aria-hidden="true">↶</span>
              Información Ejercicios Anteriores Art. 69 (48 Fracciones)
              <span className="rubros-history-arrow" aria-hidden="true">›</span>
            </Link>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Rubros;
